import React from 'react';
import { Switch } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import { Box } from '@mui/material';
import { InspectionDelayed } from 'app/modules/dashboards/dashboard-truck-implement/components/truck-implement-inspection-tab/InspectionDelayed';
import Alert from './alert';
import AlertActivation from './alert-activation';
import TruckGroup from './truck-group';
import BlockScreen from './block-screen';
import CameraDevice from './camera-device';
import CameraEvent from './camera-event';
import Company from './company';
import CompanyToken from './company-token';
import Device from './device';
import DeviceCommunication from './device-communication';
import DeviceSensor from './device-sensor';
import DeviceTruckImplement from './device-truck-implement';
import FavoriteTruck from './favorite-truck';
import FifthWheel from './fifth-wheel';
import FifthWheelConnection from './fifth-wheel-connection';
import FifthWheelHistory from './fifth-wheel-history';
import GasSupply from './gas-supply';
import IdentificationCodeAlert from './identification-code-alert';
import Inspection from './inspection';
import InspectionHistory from './inspection-history';
import InspectionItem from './inspection-item';
import InspectionItemPerformed from './inspection-item-performed';
import KpiData from './kpi-data';
import KpiLastProcessed from './kpi-last-processed';
import MaintenanceControl from './maintenance-control';
import MaintenanceModel from './maintenance-model';
import MaintenancePart from './maintenance-part';
import MaintenanceReview from './maintenance-review';
import Part from './part';
import Place from './place';
import ReportDailyVehicle from './report-daily-vehicle';
import RepresentativeCompany from './representative-company';
import RepresentativeTruckImplement from './representative-truck-implement';
import Scheduling from './scheduling';
import SchedulingHistory from './scheduling-history';
import Sensor from './sensor';
import SensorData from './sensor-data';
import SensorDataDaily from './sensor-data-daily';
import SensorHardware from './sensor-hardware';
import StatisticMarkLine from './statistic-mark-line';
import Tire from './tire';
import TireAlertSetting from './tire-alert-setting';
import TireAlertState from './tire-alert-state';
import TireManufacturer from './tire-manufacturer';
import TireModel from './tire-model';
import TireTreadManufacturer from './tire-tread-manufacturer';
import TireTreadModel from './tire-tread-model';
import TireTruckImplement from './tire-truck-implement';
import TruckImplement from './truck-implement';
import UserCustom from './user-custom';
import UserTruckImplement from './user-truck-implement';
import VehicleModel from './vehicle-model';
import VehiclePosition from './vehicle-position';
import VehiclePositionLast from './vehicle-position-last';
import VirtualFenceCircle from './virtual-fence-circle';
import VirtualFenceCircleAlert from './virtual-fence-circle-alert';
import Indicator from './indicator';
import IndicatorData from './indicator-data';
import AllowedCompanies from './allowed-companies';

// const isSmallScreen = window.innerWidth < 900;
const Routes = ({ match }) => (
  <Box component={'body'} justifyContent={'center'} sx={{ borderRadius: 0, padding: { xs: '12px', sm: '24px' } }}>
    <Switch>
      {/* prettier-ignore */}
      <ErrorBoundaryRoute path={`${match.url}company`} component={Company} />
      <ErrorBoundaryRoute path={`${match.url}user-custom`} component={UserCustom} />
      <ErrorBoundaryRoute path={`${match.url}truck-implement`} component={TruckImplement} />
      <ErrorBoundaryRoute path={`${match.url}sensor`} component={Sensor} />
      <ErrorBoundaryRoute path={`${match.url}sensor-hardware`} component={SensorHardware} />
      <ErrorBoundaryRoute path={`${match.url}device-sensor`} component={DeviceSensor} />
      <ErrorBoundaryRoute path={`${match.url}device`} component={Device} />
      <ErrorBoundaryRoute path={`${match.url}device-truck-implement`} component={DeviceTruckImplement} />
      <ErrorBoundaryRoute path={`${match.url}alert`} component={Alert} />
      <ErrorBoundaryRoute path={`${match.url}truck-group`} component={TruckGroup} />
      <ErrorBoundaryRoute path={`${match.url}camera-device`} component={CameraDevice} />
      <ErrorBoundaryRoute path={`${match.url}camera-event`} component={CameraEvent} />
      <ErrorBoundaryRoute path={`${match.url}sensor-data`} component={SensorData} />
      <ErrorBoundaryRoute path={`${match.url}sensor-data-daily`} component={SensorDataDaily} />
      <ErrorBoundaryRoute path={`${match.url}statistic-mark-line`} component={StatisticMarkLine} />
      <ErrorBoundaryRoute path={`${match.url}alert-activation`} component={AlertActivation} />
      <ErrorBoundaryRoute path={`${match.url}user-truck-implement`} component={UserTruckImplement} />
      <ErrorBoundaryRoute path={`${match.url}virtual-fence-circle`} component={VirtualFenceCircle} />
      <ErrorBoundaryRoute path={`${match.url}vehicle-position`} component={VehiclePosition} />
      <ErrorBoundaryRoute path={`${match.url}virtual-fence-circle-alert`} component={VirtualFenceCircleAlert} />
      <ErrorBoundaryRoute path={`${match.url}vehicle-model`} component={VehicleModel} />
      <ErrorBoundaryRoute path={`${match.url}part`} component={Part} />
      <ErrorBoundaryRoute path={`${match.url}place`} component={Place} />
      <ErrorBoundaryRoute path={`${match.url}maintenance-review`} component={MaintenanceReview} />
      {/* <ErrorBoundaryRoute path={`${match.url}maintenance-vehicle`} component={MaintenanceVehicle} /> */}
      <ErrorBoundaryRoute path={`${match.url}maintenance-part`} component={MaintenancePart} />
      <ErrorBoundaryRoute path={`${match.url}report-daily-vehicle`} component={ReportDailyVehicle} />
      <ErrorBoundaryRoute path={`${match.url}maintenance-control`} component={MaintenanceControl} />
      <ErrorBoundaryRoute path={`${match.url}maintenance-model`} component={MaintenanceModel} />
      <ErrorBoundaryRoute path={`${match.url}company-token`} component={CompanyToken} />
      <ErrorBoundaryRoute path={`${match.url}identification-code-alert`} component={IdentificationCodeAlert} />
      <ErrorBoundaryRoute path={`${match.url}tire`} component={Tire} />
      <ErrorBoundaryRoute path={`${match.url}tire-manufacturer`} component={TireManufacturer} />
      <ErrorBoundaryRoute path={`${match.url}tire-model`} component={TireModel} />
      <ErrorBoundaryRoute path={`${match.url}tire-tread-manufacturer`} component={TireTreadManufacturer} />      
      <ErrorBoundaryRoute path={`${match.url}tire-tread-model`} component={TireTreadModel} />      
      <ErrorBoundaryRoute path={`${match.url}tire-alert-setting`} component={TireAlertSetting} />
      <ErrorBoundaryRoute path={`${match.url}tire-alert-state`} component={TireAlertState} />
      <ErrorBoundaryRoute path={`${match.url}tire-truck-implement`} component={TireTruckImplement} />
      <ErrorBoundaryRoute path={`${match.url}inspection-item`} component={InspectionItem} />
      <ErrorBoundaryRoute path={`${match.url}inspection`} component={Inspection} />
      <ErrorBoundaryRoute path={`${match.url}inspection-item-performed`} component={InspectionItemPerformed} />
      <ErrorBoundaryRoute path={`${match.url}inspection-history`} component={InspectionHistory} />
      <ErrorBoundaryRoute path={`${match.url}inspection-delayed`} component={InspectionDelayed} />
      <ErrorBoundaryRoute path={`${match.url}device-communication`} component={DeviceCommunication} />
      <ErrorBoundaryRoute path={`${match.url}favorite-truck`} component={FavoriteTruck} />
      <ErrorBoundaryRoute path={`${match.url}representative-company`} component={RepresentativeCompany} />
      <ErrorBoundaryRoute path={`${match.url}representative-truck-implement`} component={RepresentativeTruckImplement} />
      <ErrorBoundaryRoute path={`${match.url}scheduling`} component={Scheduling} />
      <ErrorBoundaryRoute path={`${match.url}scheduling-history`} component={SchedulingHistory} />
      <ErrorBoundaryRoute path={`${match.url}gas-supplies`} component={GasSupply} />

      {/* <PrivateRouteComponent path={`${match.url}truck-device-status`} component={TruckDeviceStatus} hasAnyAuthorities={[AUTHORITIES.ADMIN]}/> */}
      {/* <PrivateRouteComponent path={`${match.url}truck-device-status-history`} component={TruckDeviceStatusHistory} hasAnyAuthorities={[AUTHORITIES.ADMIN]}/> */}
      <ErrorBoundaryRoute path={`${match.url}kpi-data`} component={KpiData} />
      <ErrorBoundaryRoute path={`${match.url}kpi-last-processed`} component={KpiLastProcessed} />
      <ErrorBoundaryRoute path={`${match.url}indicator`} component={Indicator} />
      <ErrorBoundaryRoute path={`${match.url}indicator-data`} component={IndicatorData} />
      <ErrorBoundaryRoute path={`${match.url}block-screen`} component={BlockScreen} />
      <ErrorBoundaryRoute path={`${match.url}fifth-wheel`} component={FifthWheel} />
      <ErrorBoundaryRoute path={`${match.url}fifth-wheel-connection`} component={FifthWheelConnection} />
      <ErrorBoundaryRoute path={`${match.url}fifth-wheel-history`} component={FifthWheelHistory} />
      <ErrorBoundaryRoute path={`${match.url}vehicle-position-last`} component={VehiclePositionLast} />
      <ErrorBoundaryRoute path={`${match.url}allowed-companies`} component={AllowedCompanies} />
      {/* jhipster-needle-add-route-path - JHipster will add routes here */}
    </Switch>
  </Box>
);

export default Routes;
